import React, { useEffect, useState, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import { Link, useParams, withRouter, useHistory } from "react-router-dom";
import
{
  CardBody,
  Container,
  Row,
  Card,
  CardHeader,
  Spinner,
  Alert,
  Col,
  Modal,
  Form,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
} from "reactstrap";


// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Breadcrumb
import BreadCrumb from "../../../../Components/Common/BreadCrumb";

import TableContainer from "../../../../Components/Common/TableContainer";
//Import actions
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../../axiosConfig";
import TakciLogo from "../../../../assets/images/logo-light.png";

//redux
import { useDispatch } from "react-redux";

import Loader from "../../../../Components/Common/Loader";
import Key from "../../../../key";
import InfosEvent from "../../../../Components/Common/InfosEvent";


import moment from "moment";
import "moment/locale/fr";
import UpdateTicketModal from "../Components/UpdateTickets";
import { lireRoleSession } from "../../../../espace";


moment.locale( "fr" );

const EventActivityHistory = ( props ) =>
{
  const history = useHistory();
  function formatDate ( date )
  {
    const dateObject = new Date( date ).toLocaleDateString( "fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric"
    } );
    return dateObject;
  }

  const { id: eventId } = useParams();
  const [ loading, setLoading ] = useState( true );
  const [ selectEvenement, setSelectEvenement ] = useState( {} );
  const [ billetEvenement, setBilletEvenement ] = useState( {} );


  const [ roleSession, setRoleSession ] = useState( lireRoleSession )
  const [ idConnected, setIdConnected ] = useState( null )
  function getSessionData ()
  {
    if ( localStorage.getItem( "authUser" ) )
    {
      const obj = JSON.parse( localStorage.getItem( "authUser" ) );
      // console.log( 'obj localStorage:', obj )
      setRoleSession( obj.role )

      if ( obj.data )
      {
        setIdConnected( obj.data.id )
      }
    }
  }

  const [ loadingTicket, setLoadingTicket ] = useState( true );

  const fetchEventTicketData = useCallback( async () =>
  {
    try
    {
      const ticketDetailResponse = await axiosInstance.get(
        `/billetgetforevent/?event_id=${ eventId }/`
      );
      // console.log( 'Billet Event: ', ticketDetailResponse.data.data )
      setBilletEvenement( ticketDetailResponse.data.data );
    } catch ( err )
    {
      console.error( "Échec de récupération des tickets: ", err );
      toast.error( "Échec de récupération des tickets." );
    }

    setLoadingTicket( false );
  }, [] );

  const fetchEventData = useCallback( async () =>
  {
    try
    {
      const eventDetailResponse = await axiosInstance.get(
        `/eventgetone/?event_id=${ eventId }/`
      );
      // console.log( "eventDetailResponse.data.data: ", eventDetailResponse.data.data )
      setSelectEvenement( eventDetailResponse.data.data );

    } catch ( err )
    {
      console.error( "Échec de récupération des données relatives à l'événement. Erreur: ", err );
      toast.error( "Échec de récupération des données relatives à l'événement." );
    }

    setLoading( false );
  }, [] ); // Add eventId to the dependencies array


  const [ ticket, setTicket ] = useState( {} )
  const [ modalUpdateTicket, setModalUpdateTicket ] = useState( false );
  const handleClickTicket = useCallback( ( arg ) =>
  {
    setTicket(
      {
        id: arg.id,
        categorie: arg.categorie,
        montant: arg.montant,
        quantite: arg.quantite,
        color_billet: arg.color_billet,
        event_id: arg.event_id
      }
    );

  }, [] );

  useEffect( () =>
  {
    getSessionData()
    fetchEventData();
    fetchEventTicketData();
  }, [] );


  const fetchPromotionTicket = useCallback( async ( idTicket ) =>
  {
    try
    {
      const promotionTicket = await axiosInstance.get(
        `/codereductionbillet/?billet_id=${ idTicket }/`
      );
      if ( promotionTicket.status === 200 )
      {
        // console.log( 'Promote Event: ', promotionTicket.data.data )
        setPromotions( promotionTicket.data.data );

        // setLoadingTicket( true );
        // fetchEventTicketData();
      }
    } catch ( err )
    {
      console.error( "Échec de récupération des tickets: ", err );
      toast.error( "Échec de récupération des tickets." );
    }

    setLoadingPromotions( false );
  }, [] );

  const columnsTable = useMemo(
    () => [
      {
        Header: "Numero Billet",
        accessor: "numero",
        filterable: false,
      },
      {
        Header: "Catégorie",
        accessor: "categorie",
        filterable: false,
      },
      {
        Header: "Quantité",
        accessor: "quantite",
        filterable: false,
      },
      {
        Header: "Vendu",
        accessor: "vendu",
        filterable: false,
      },
      {
        Header: "Montant",
        accessor: "montant",
        filterable: false,
      },
      {
        Header: "Code de reduction",
        accessor: "code_reduction",
        filterable: false,
        Cell: ( item ) => (
          <ul className="list-inline hstack gap-2 mb-0">
            <span className="me-1">
              { item.row.original.code_reduction }
            </span>
            { roleSession === "ORGANISATEUR" && (
              <button
                onClick={ async ( e ) =>
                {
                  e.preventDefault();
                  setModalPromotions( true );
                  setLoadingPromotions( true )
                  await fetchPromotionTicket( item.row.original.id );
                } }
                className="btn btn-sm text-primary cursor-pointer"
              >
                <i className="ri-eye-fill align-bottom"></i>
              </button>
            ) }
          </ul>
        ),
      },
      {
        Header: "Date",
        accessor: "created_at",
        filterable: false,
        Cell: ( cellProps ) =>
        {
          return formatDate( cellProps.row.original.created_at );
        },
      },
      {
        Header: props.t( "Actions" ),
        accessor: "id",
        filterable: false,
        Cell: ( item ) => (
          <ul className="list-inline hstack gap-2 mb-0">
            {
              roleSession === "ORGANISATEUR" &&
              <>
                <button
                  onClick={ ( e ) =>
                  {
                    e.preventDefault();
                    handleClickTicket( item.row.original );
                    setModalSavePromotion( true );

                  } }
                  className="btn btn-outline-success btn-sm"
                >
                  <i className="bx bxs-megaphone align-bottom"></i>
                </button>

                <button
                  onClick={ ( e ) =>
                  {
                    e.preventDefault();
                    handleClickTicket( item.row.original );
                    setModalUpdateTicket( true );
                  } }
                  className="btn btn-outline-warning btn-sm"
                >
                  <i className="ri-pencil-fill align-bottom"></i>
                </button>

                <Link
                  to="#"
                  className="btn btn-sm btn-outline-danger d-inline-block"
                  onClick={ ( e ) =>
                  {
                    e.preventDefault();
                    handleClickTicket( item.row.original )
                    setModalConfirmDelete( true );
                  } }
                >
                  <i className=" bx bx-trash align-middle"></i>
                  {/* Supprimer */ }
                </Link>
              </>
            }

            < Link
              to={ `/evenements/billets/${ item.row.original.id }` }
              className="btn btn-primary btn-sm"
            >
              <i className="ri-eye-fill align-bottom"></i>
            </Link >
          </ul >
        ),
      }
    ], [ roleSession, fetchPromotionTicket ]
  );

  const columnsInfo = [
    {
      Header: "Nom",
      accessor: "nom",
    },
    {
      Header: "Catégorie",
      accessor: "categorie",
    },
    {
      Header: "Numero à contacter",
      accessor: "numero",
    },
    {
      Header: "Organisateur Nom",
      accessor: "organisateur_last_name",
    },
    {
      Header: "Organisateur Prénom",
      accessor: "organisateur_first_name",
    },
    {
      Header: "Date",
      accessor: "date",
      cell: ( item ) => (
        item.date ? `${ moment( item.date ).format( "YYYY-MM-DD" ) } à ${ item.heure }` : "Date invalide"
      ),
    },
    {
      Header: "Date fin",
      accessor: "date_fin",
      cell: ( item ) => (
        item.date_fin ? `${ moment( item.date_fin ).format( "YYYY-MM-DD" ) } à ${ item.heure_fin }` : "Date invalide"
      ),
    },

    {
      Header: "Date fin de vente",
      accessor: "date_fin_vente",
      cell: ( item ) => (
        item.date_fin_vente ? `${ moment( item.date_fin_vente ).format( "YYYY-MM-DD" ) }` : "Date invalide"
      ),
    },
    {
      Header: "Lieu",
      accessor: "lieu",
    },
    {
      Header: "Etat",
      accessor: "publier",
    },
    { Header: "Description", accessor: "description" },
  ];

  const [ loadingSaveBillet, setLoadingSaveBillet ] = useState( false )

  const [ billetsEvent, setBilletsEvent ] = useState( [ {
    categorie: '',
    montant: '',
    quantite: '',
    color_billet: '#011866',
    event_id: eventId
  } ] );

  const [ modalAddTicket, setModalAddTicket ] = useState( false );

  const handleAddForm = () =>
  {
    setBilletsEvent( [ ...billetsEvent,
    {
      categorie: '',
      montant: '',
      quantite: '',
      color_billet: '#011866',
      event_id: eventId
    } ] );

  };

  const handleRemoveForm = ( index ) =>
  {
    const newFormData = [ ...billetsEvent ];
    if ( Object.keys( newFormData ).length > 1 )
    {
      newFormData.splice( index, 1 );
      setBilletsEvent( newFormData );
    }
  };


  const handleChangeCategorieBillet = ( index, event ) =>
  {
    const { name, value } = event.target;
    // console.log( `name ${ name } ${ index }: `, value )
    const newFormData = [ ...billetsEvent ];
    // console.log( "newFormData: ", newFormData )
    newFormData[ index ][ name ] = value;
    setBilletsEvent( newFormData );
  };

  const [ isFormDataEmpty, setIsFormDataEmpty ] = useState( true )
  useEffect( () =>
  {
    const isFormDataEmpty = billetsEvent.every( item =>
    {
      return (
        item.categorie !== "" && item.categorie !== null && item.categorie !== undefined
        &&
        item.montant !== "" && item.montant !== null && item.montant !== undefined
        &&
        item.quantite !== "" && item.quantite !== null && item.quantite !== undefined
        &&
        item.color_billet !== "" && item.color_billet !== null && item.color_billet !== undefined
      )
    } );
    setIsFormDataEmpty( !isFormDataEmpty );
  }, [ billetsEvent ] );


  const eventBilletSubmit = async ( event ) =>
  {
    setLoadingSaveBillet( true )
    event.preventDefault();
    try
    {
      const isFormDataEmpty = billetsEvent.every( item =>
        Object.values( item ).every( value => value === '' || value === null || value === undefined )
      );
      // console.log( "billetsEvent: ", billetsEvent );

      if ( isFormDataEmpty )
      {
        // toast.error( "Il y a des champs vides..." )
      } else
      {
        // Enrégistrer les données
        // console.log( "Enrégistrer les données..." )

        const res = await axiosInstance.post( "/billetcreate/", billetsEvent );
        // console.log( "res billetcreate submit: ", res );
        if ( res.status === 200 )
        {
          setLoadingTicket( true );
          fetchEventTicketData();
          setBilletsEvent( [
            {
              categorie: '',
              montant: '',
              quantite: '',
              color_billet: '',
              event_id: eventId
            } ]
          );
          setModalAddTicket( false );

          toast.success( ( "Billet.s de l'événement sauvegardé.s avec succès" ), {
            autoClose: 3000,
          } );
        } else
        {
          toast.error( ( "Erreur lors de la sauvegarde de l'evenement" ), {
            autoClose: 3000,
          } );
        }
      }
    } catch ( error )
    {
      toast.error( ( "Erreur lors de la sauvegarde des billets de l'événement" ), {
        autoClose: 3000,
      } );
      console.error( "Erreur lors de la sauvegarde des billets de l'événement", error )
    }
    setLoadingSaveBillet( false )
  }


  const [ modalConfirmDelete, setModalConfirmDelete ] = useState( false );
  const handleDelete = async () =>
  {
    // console.log( "data delete: ", {
    //   billet_id: ticket.id,
    // } )
    await axiosInstance.delete( `/deletebillet/?billet_id=${ ticket.id }` ).then( ( res ) =>
    {
      // console.log(res);
      toast.success( "Ticket supprimé avec succès" );
      // dispatch( onGetCodePromos() );
      setLoadingTicket( true );
      fetchEventTicketData();
    } ).catch( ( err ) =>
    {
      console.error( "Erreur lors de la supression du ticket. Erreur: ", err );
      toast.error( "Erreur lors de la supression du ticket" );
    } );

    setModalConfirmDelete( false );

    setTicket( {} );
  };

  const columnsPromotionTable = useMemo(
    () => [
      {
        Header: "Code",
        accessor: "code",
        filterable: false,
      },
      {
        Header: "Pourcentage",
        accessor: "pourcentage",
        filterable: false,
      },

      roleSession === "ORGANISATEUR" &&
      {
        Header: props.t( "Actions" ),
        accessor: "id",
        filterable: false,
        Cell: ( item ) => (
          <ul className="list-inline hstack gap-2 mb-0">
            <>
              <button
                onClick={ ( e ) =>
                {
                  e.preventDefault();
                  handleClickPromotion( item.row.original );
                  setModalSavePromotion( true );
                  setEditPromotion( true );
                } }
                className="btn btn-outline-warning btn-sm"
              >
                <i className="ri-pencil-fill align-bottom"></i>
              </button>
              <Link
                to="#"
                className="btn btn-sm btn-outline-danger d-inline-block"
                onClick={ ( e ) =>
                {
                  e.preventDefault();
                  handleClickPromotion( item.row.original );
                  setModalConfirmPromoteDelete( true );
                } }
              >
                <i className=" bx bx-trash align-middle"></i>
                {/* Supprimer */ }
              </Link>
            </>
          </ul >
        ),
      }
    ], [ roleSession ]
  );
  const [ loadingSavePromotion, setLoadingSavePromotion ] = useState( false )
  const [ modalPromotions, setModalPromotions ] = useState( false )
  const [ modalSavePromotion, setModalSavePromotion ] = useState( false )
  const [ loadingPromotions, setLoadingPromotions ] = useState( false )
  const [ promotions, setPromotions ] = useState( [] );
  const [ promotion, setPromotion ] = useState( {} );
  const [ editPromotion, setEditPromotion ] = useState( false );
  const handleClickPromotion = useCallback( ( arg ) =>
  {
    // console.log( "arg: ", arg );
    setPromotion(
      {
        id: arg.id,
        code: arg.code,
        pourcentage: arg.pourcentage,
        event_id: arg.event_id,
        billet_id: arg.billet_id
      }
    );

  }, [] );

  const [ modalConfirmPromoteDelete, setModalConfirmPromoteDelete ] = useState( false );
  const handleDeletePromote = async () =>
  {
    setLoadingPromotions( true )
    // console.log( "data delete: ", {
    //   billet_id: ticket.id,
    // } )
    // deletecodepromoevent

    await axiosInstance.delete( `/deletecodepromoevent/?code_id=${ promotion.id }` ).then( ( res ) =>
    {
      // console.log(res);
      toast.success( "Promotion supprimée avec succès" );
      setModalPromotions( false );
      setLoadingTicket( true )
      fetchEventTicketData();
    } ).catch( ( err ) =>
    {
      console.error( err );
      toast.error( "Erreur lors de la supression de la promotion" );
    } );

    setModalConfirmPromoteDelete( false );
    setLoadingPromotions( false )
    setPromotion( {} );
  };

  const validationPromoteTicket = useFormik( {
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      code: promotion.code || "",
      pourcentage: promotion.pourcentage || ""
    },
    validationSchema: Yup.object( {
      pourcentage: Yup.number()
        .min( 1, "La quantite ne peut pas être inférieur à 0" )
        .max( 100, "La quantite ne peut pas être supérieur à 100" )
        .required(
          props.t( "Veuillez renseigner la pourcentage" )
        )
    } ),
    onSubmit: async ( values ) =>
    {
      setLoadingPromotions( true );
      setLoadingSavePromotion( true )

      if ( editPromotion )
      {
        // console.log( "promotion: ", promotion )
        const dataPromotionUpdate = {
          ...values,
          code_id: promotion.id,
        }
        // console.log( "dataPromotionUpdate: ", dataPromotionUpdate );
        // console.log( "Modification de la promotion..." )
        try
        {
          const data = axiosInstance.post( `/codepromoupdate/`, dataPromotionUpdate ).then(
            async ( response ) =>
            {
              // console.log( 'response codepromoupdate: ', response )
              validationPromoteTicket.resetForm();
              toast.success( props.t( "Réduction modifiée avec succès" ), {
                autoClose: 3000,
              } );

              setLoadingPromotions( true );
              await fetchEventTicketData();
              await fetchPromotionTicket( ticket.id );

            } ).catch(
              ( error ) =>
              {
                console.error( "Echec de la modification de la réduction sur le ticket. Erreur: ", error );
                toast.error( props.t( "Echec de la modification de la réduction sur le ticket" ), {
                  autoClose: 3000,
                } );
              }
            );

        } catch ( err )
        {
          console.error( err );
          toast.error( props.t( "Echec de la modification de reduction du ticket" ), {
            autoClose: 2000,
          } );
        }
        setEditPromotion( false )
      } else
      {
        const dataPromotionAdd = {
          ...values,
          billet_id: ticket.id,
          event_id: eventId
        }
        // console.log( "dataPromotionAdd: ", dataPromotionAdd );

        // console.log( "Ajout de la promotion..." )
        try
        {
          const data = axiosInstance.post( `/codepromocreate/`, dataPromotionAdd ).then(
            async ( response ) =>
            {
              // console.log( 'response codepromocreate: ', response )
              validationPromoteTicket.resetForm();
              toast.success( props.t( "Réduction ajoutée avec succès" ), {
                autoClose: 3000,
              } );
              setLoadingPromotions( true );
              await fetchPromotionTicket( ticket.id );
              await fetchEventTicketData();
            } ).catch(
              ( error ) =>
              {
                console.error( "Echec de l'ajout de la réduction sur le ticket. Erreur: ", error );
                toast.error( props.t( "Echec de l'ajout de la réduction sur le ticket" ), {
                  autoClose: 3000,
                } );
              }
            );

        } catch ( err )
        {
          console.error( err );
          toast.error( props.t( "Echec de l'ajout de reduction au ticket" ), {
            autoClose: 2000,
          } );
        }
      }



      setTicket( {} );
      setPromotion( {} );
      setLoadingPromotions( false );
      setModalSavePromotion( false );
      setLoadingSavePromotion( false )
    },
  } );

  document.title = props.t( "Détails de l'evénement | Takci" );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Détails de l'evénement"
            pageTitle="EVÉNEMENTS"
            pageTitleLink="/evenements"
          />
          { loading ? (
            <div className="text-center my-5">
              <Loader style={ { color: "#014c94" } } />
              <h2>Chargement...</h2>
            </div>
          ) : (
            <Row g={ 2 } className="my-2 g-2">
              <Col xxl={ 3 }>
                <Card className="w-100 h-100">
                  { Object.keys( selectEvenement ).length > 0 ? (
                    <InfosEvent
                      idOrganizer={ idConnected }
                      status={ selectEvenement.status && selectEvenement.status }
                      avatar={
                        selectEvenement.logo ? (
                          <div className="avatar-lg">
                            <img
                              src={ Key.logoURL + selectEvenement.logo }
                              alt="event-logo"
                              className="img-thumbnail rounded-circle w-100"
                            />
                          </div>
                        ) : (
                          <div className="avatar-lg">
                            <img
                              src={ TakciLogo }
                              alt="Takci-logo"
                              className="img-thumbnail rounded-circle w-100"
                            // style={{ background: "#002437" }}
                            />
                          </div>
                        )
                      }
                      banner={
                        Key.baniereURL + selectEvenement.banniere
                      }
                      head={ selectEvenement.nom && selectEvenement.nom }
                      columns={ columnsInfo }
                      data={ selectEvenement && selectEvenement }
                      updated={ roleSession === "ORGANISATEUR" }
                    />
                  ) : (
                    <Alert color="warning" className="text-center">
                      Aucune information disponible.
                    </Alert>
                  ) }
                </Card>
              </Col>

              <Col xxl={ 9 }>
                <Card className="w-100 h-100">
                  {
                    loadingTicket ?
                      <div className="d-flex text-center">
                        <Spinner size={ "lg" } />
                        <span className="ms-1">Chargement...</span>
                      </div>
                      :
                      <Card>
                        <CardHeader className="fw-bold d-flex justify-content-between">
                          Liste des Tickets
                          {
                            Object.keys( selectEvenement ).length > 0 &&
                            roleSession === "ORGANISATEUR" &&
                            <button
                              disabled={ Object.keys( selectEvenement ).length < 0 || roleSession !== "ORGANISATEUR" }
                              onClick={ () =>
                                setModalAddTicket( true )
                              }
                              className="btn btn-outline-primary d-flex"
                            >
                              <i className="ri-add align-bottom"></i>
                              <span className="ms-1">
                                Ajouter un ticket
                              </span>
                            </button>
                          }
                        </CardHeader>
                        <CardBody>
                          {

                            billetEvenement.length > 0 ?
                              <div className="table-card grid js-border-none pb-2">
                                <TableContainer
                                  columns={ columnsTable }
                                  data={ billetEvenement || [] }
                                  isGlobalFilter={ false }
                                  isAddUserList={ false }
                                  customPageSize={ 10 }
                                  divClass="table-responsive"
                                  tableClass="mb-0 table-borderless"
                                  theadClass="table-light text-muted"
                                />
                              </div>
                              : (
                                <Alert color="warning">Aucun ticket disponible.</Alert>
                              )
                          }
                        </CardBody>
                      </Card>
                  }
                </Card>
              </Col>
            </Row>
          ) }
          <ToastContainer closeButton={ false } />
        </Container>
      </div>

      {/* Modal Add billet*/ }
      <Modal
        id="showModal"
        style={ { maxWidth: 800 } }
        isOpen={ modalAddTicket }
        centered
      >
        <ModalHeader className="bg-soft-info p-3">
          Ajout de ticket.s
        </ModalHeader>

        {/* Modal add billet*/ }

        <Form onSubmit={ eventBilletSubmit }>
          <Card>
            <CardBody>
              <Row>
                {
                  billetsEvent.length > 0 && billetsEvent.map( ( form, index ) =>
                  {
                    return (
                      <Row className="g-2" key={ index }>
                        <Col md={ 12 } className="">
                          <span className='fw-bold'>
                            Billet { index + 1 } :
                          </span>
                        </Col>

                        <Col md={ 6 } lg={ 4 } xxl={ 3 }>
                          <label htmlFor={ `categorie-${ index }` } className="form-label fs-7">
                            Catégorie du billet :
                          </label>
                          <input
                            type="text"
                            id={ `categorie-${ index }` }
                            name={ `categorie` }
                            placeholder={ `Nom de catégorie ${ index + 1 }` }
                            required
                            className="form-control"
                            value={ form.categorie }
                            onChange={ ( e ) => handleChangeCategorieBillet( index, e ) }
                          />
                        </Col>

                        <Col md={ 6 } lg={ 4 } xxl={ 3 }>
                          <label htmlFor={ `quantite-${ index }` } className="form-label fs-7">
                            Quantité :
                          </label>
                          <input
                            type="number"
                            min="1"
                            id={ `quantite-${ index }` }
                            name={ `quantite` }
                            required
                            className="form-control"
                            placeholder={ `Quantité de catégorie ${ index + 1 }` }
                            value={ form.quantite }
                            onChange={ ( e ) => handleChangeCategorieBillet( index, e ) }
                          />
                        </Col>

                        <Col md={ 6 } lg={ 4 } xxl={ 3 }>
                          <label htmlFor={ `montant-${ index }` } className="form-label fs-7">
                            Montant :
                          </label>
                          <input
                            type="number"
                            min="100"
                            id={ `montant-${ index }` }
                            name={ `montant` }
                            required
                            className="form-control"
                            placeholder={ `Montant de catégorie ${ index + 1 }` }
                            value={ form.montant }
                            onChange={ ( e ) => handleChangeCategorieBillet( index, e ) }
                          />
                        </Col>

                        <Col md={ 6 } lg={ 4 } xxl={ 3 }>
                          <label htmlFor={ `color_billet-${ index }` } className="form-label fs-7">
                            Couleur du Billet :
                          </label>
                          <input
                            type="color"
                            min="100"
                            id={ `color_billet-${ index }` }
                            name={ `color_billet` }
                            required
                            className="form-control"
                            value={ form.color_billet }
                            onChange={ ( e ) => handleChangeCategorieBillet( index, e ) }
                          />
                        </Col>

                        {
                          !loadingSaveBillet &&
                          Object.keys( billetsEvent ).length > 1 &&
                          <Col md={ 6 } lg={ 4 } xxl={ 3 } className="text-end align-content-end">
                            <button className="btn btn-danger" type="button" onClick={ () => handleRemoveForm( index ) }>
                              Supprimer
                            </button>
                          </Col>
                        }
                        {
                          Object.keys( billetsEvent ).length !== index + 1 ?
                            <hr /> :
                            <div className="mb-3" />
                        }
                      </Row>
                    )
                  } ) }

                {
                  !loadingSaveBillet &&
                  <div className="text-center mb-3">
                    <button disabled={ isFormDataEmpty } className={ `btn ${ !isFormDataEmpty ? "btn-outline-primary" : "btn-danger" }` } type="button" id="button-addon2" onClick={ handleAddForm }>
                      { !isFormDataEmpty ?
                        "Ajouter une catégorie"
                        : "Veuillez remplir les champs existants"
                      }
                    </button>
                  </div>
                }

              </Row>
            </CardBody>
          </Card>

          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <Button
                type="button"
                onClick={ () =>
                {
                  setModalAddTicket( false );
                } }
                className="btn-light"
              >
                { ( "Fermer" ) }
              </Button>

              {/* <button type="button" className="btn btn-light" onClick={() => { setModal(false);dispatch(onGetCodePromos); }} > {("Fermer")} </button> */ }

              {
                !isFormDataEmpty &&
                <Button disabled={ loadingSaveBillet } type="submit" className="btn btn-primary text-center">
                  {
                    loadingSaveBillet ?
                      <div className="d-flex justify-center">
                        <Spinner size={ "sm" } />
                        <span>
                          chargement...
                        </span>
                      </div> :
                      <span>
                        Ajouter le{ Object.keys( billetsEvent ).length > 1 && "s" } billet{ Object.keys( billetsEvent ).length > 1 && "s" }
                      </span>
                  }
                </Button>
              }
            </div>
          </ModalFooter>
        </Form>
      </Modal>

      {/* Modal Update billet*/ }
      <UpdateTicketModal
        ticket={ ticket }
        setTicket={ setTicket }
        loadingSaveBillet={ loadingSaveBillet }
        setLoadingSaveBillet={ setLoadingSaveBillet }
        modalUpdateTicket={ modalUpdateTicket }
        setModalUpdateTicket={ setModalUpdateTicket }
        loadingTicket={ loadingTicket }
        setLoadingTicket={ setLoadingTicket }
        fetchEventTicketData={ fetchEventTicketData }
        billetEvenement={ billetEvenement }
        setBilletEvenement={ setBilletEvenement }
      />

      {/* handleDelete Ticket */ }
      <Modal
        id="showModalConfirmDelete"
        style={ { maxWidth: 800 } }
        isOpen={ modalConfirmDelete }
        centered
      >
        <ModalBody className="py-3 px-5">
          <div className="mt-2 text-center">
            <lord-icon
              src="https://cdn.lordicon.com/gsqxdxog.json"
              trigger="loop"
              colors="primary:#014c94,secondary:#eac22f"
              style={ { width: "100px", height: "100px" } }
            ></lord-icon>
            <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
              <h4>Êtes-vous sûr ?</h4>
              <p className="text-muted mx-4 mb-0">
                Êtes-vous sûr de vouloir supprimer ce ticket ?
              </p>
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
            <button
              type="button"
              className="btn w-sm btn-light"
              data-bs-dismiss="modal"
              onClick={ () =>
              {
                setModalConfirmDelete( false );
              } }
            >
              Fermer
            </button>
            <button
              type="button"
              className="btn w-sm btn-danger"
              id="delete-organizer"
              onClick={ handleDelete }
            >
              Oui, supprimez-le !
            </button>
          </div>
        </ModalBody>
      </Modal>

      {/* Liste des Promotions */ }
      <Modal
        id="showModal"
        style={ { maxWidth: 800 } }
        isOpen={ modalPromotions }
        centered
      >
        <ModalHeader className="bg-soft-info p-3">
          Liste des Promotions
        </ModalHeader>
        <CardBody>
          {
            loadingPromotions ? (
              <div className="text-center my-5">
                <Loader style={ { color: "#014c94" } } />
                <h2>Chargement...</h2>
              </div>
            ) :
              promotions.length > 0 ?
                <Col xs={ 12 }>
                  <TableContainer
                    columns={ columnsPromotionTable }
                    data={ promotions }
                    isGlobalFilter={ true }
                    isAddUserList={ false }
                    customPageSize={ 8 }
                    className="custom-header-css"
                    divClass="table-responsive table-card mb-3"
                    tableClass="align-middle table-nowrap"
                    theadClass="table-light"
                  // handleChauffeurClick={handleChauffeurClicks}
                  />
                </Col>
                :
                <Col xs={ 12 } className="text-center">
                  <div className=" my-2 text-lg">
                    Aucune reduction
                  </div>
                  <button onClick={ () => setModalSavePromotion( true ) } className="btn btn-primary">
                    Ajouter
                  </button>
                </Col>
          }
        </CardBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
            <Button
              type="button"
              onClick={ () =>
              {
                setModalPromotions( false );
              } }
              className="btn-light"
            >
              { ( "Fermer" ) }
            </Button>
          </div>
        </ModalFooter>
      </Modal>



      {/* Modal Add billet*/ }
      <Modal
        id="showModal"
        style={ { maxWidth: 800 } }
        isOpen={ modalSavePromotion }
        centered
      >
        <ModalHeader className="bg-soft-info p-3">
          { editPromotion ? "Modification du code de reduction" : "Ajout de code de reduction" }
        </ModalHeader>

        {/* Modal add billet*/ }

        <Form onSubmit={ validationPromoteTicket.handleSubmit }>
          <Card>
            <CardBody>
              <Row>
                {
                  editPromotion &&
                  <Col md={ editPromotion ? 6 : 12 }>
                    <label htmlFor={ `code-promotion` } className="form-label fs-7">
                      Code de reduction :
                    </label>
                    <Input
                      type="text"
                      id={ `code-promotion` }
                      name={ `code` }
                      required
                      readOnly
                      className="form-control"
                      placeholder={ `Code de reduction` }
                      validate={ {
                        required: { value: true },
                      } }
                      onChange={ validationPromoteTicket.handleChange }
                      onBlur={ validationPromoteTicket.handleBlur }
                      value={ validationPromoteTicket.values.code }
                      invalid={
                        validationPromoteTicket.touched.code &&
                          validationPromoteTicket.errors.code
                          ? true
                          : false
                      }
                    />
                  </Col>
                }
                <Col md={ editPromotion ? 6 : 12 }>
                  <label htmlFor={ `pourcentage-promotion` } className="form-label fs-7">
                    Pourcentage :
                  </label>
                  <Input
                    type="number"
                    min="1"
                    max="100"
                    id={ `pourcentage-promotion` }
                    name={ `pourcentage` }
                    required
                    className="form-control"
                    placeholder={ `Pourcentage de reduction` }
                    validate={ {
                      required: { value: true },
                    } }
                    onChange={ validationPromoteTicket.handleChange }
                    onBlur={ validationPromoteTicket.handleBlur }
                    value={ validationPromoteTicket.values.pourcentage }
                    invalid={
                      validationPromoteTicket.touched.pourcentage &&
                        validationPromoteTicket.errors.pourcentage
                        ? true
                        : false
                    }
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>

          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <Button
                type="button"
                onClick={ () =>
                {
                  setModalSavePromotion( false );
                } }
                className="btn-light"
              >
                { ( "Fermer" ) }
              </Button>

              <Button disabled={ loadingSavePromotion } type="submit" className="btn btn-primary text-center">
                {
                  loadingSavePromotion ?
                    <div className="d-flex justify-center">
                      <Spinner size={ "sm" } />
                      <span>
                        chargement...
                      </span>
                    </div> :
                    <span>
                      Ajouter la promotion
                    </span>
                }
              </Button>
            </div>
          </ModalFooter>
        </Form>
      </Modal>

      {/* handleDeletePromote */ }
      <Modal
        id="showModalConfirmDeletePromote"
        style={ { maxWidth: 800 } }
        isOpen={ modalConfirmPromoteDelete }
        centered
      >
        <ModalBody className="py-3 px-5">
          <div className="mt-2 text-center">
            <lord-icon
              src="https://cdn.lordicon.com/gsqxdxog.json"
              trigger="loop"
              colors="primary:#014c94,secondary:#eac22f"
              style={ { width: "100px", height: "100px" } }
            ></lord-icon>
            <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
              <h4>Êtes-vous sûr ?</h4>
              <p className="text-muted mx-4 mb-0">
                Êtes-vous sûr de vouloir supprimer cette promotion ?
              </p>
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
            <button
              type="button"
              className="btn w-sm btn-light"
              data-bs-dismiss="modal"
              onClick={ () =>
              {
                setModalConfirmPromoteDelete( false );
              } }
            >
              Fermer
            </button>
            <button
              type="button"
              className="btn w-sm btn-danger"
              id="delete-organizer"
              onClick={ handleDeletePromote }
            >
              Oui, supprimez-la !
            </button>
          </div>
        </ModalBody>
      </Modal>

    </React.Fragment>
  );
};

EventActivityHistory.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter( withTranslation()( EventActivityHistory ) );
